module.exports = __webpack_public_path__ + "img/ipc_service3.4a653478.png";